/* ADD GROUPS */
export const ADD_GROUP = "ADD_GROUP"
export const ADD_GROUP_SUCCESS = "ADD_GROUP_SUCCESS"
export const ADD_GROUP_CLEAN = "ADD_GROUP_CLEAN"
export const API_ERROR = "API_ERROR"
